import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";
import { Modal } from "react-bootstrap";
import Button from "react-bootstrap-button-loader";
import { resetPasswordModal, resetUserPassword } from "DashboardUserAction";
import { showError, showSuccess } from "ReduxErrorBar";
import LocaleStrings from "Languages";
import { COMMON_FAIL_MESSAGE } from "Constants";

class UserResetPassword extends Component {
  constructor(props) {
    super(props);
    this.state = { loading: false };
    this.closeModal = this.closeModal.bind(this);
  }

  closeModal() {
    this.props.resetPasswordModal({ show: false });
  }

  renderFieldText(field) {
    var divClassName = `form-group row ${
      field.meta.touched && field.meta.error ? "has-danger" : ""
    }`;
    var labelClasses = "control-label col-sm-3";
    var inputClasses = "col-sm-9 col-sm-offset-0";

    return (
      <div className={divClassName}>
        <label className={labelClasses}>
          {field.label}
          <span className="label-mandatory">
            {field.mandatory === "true" ? "*" : ""}
          </span>
        </label>

        <div className={inputClasses}>
          <input
            className="form-control"
            type={field.type}
            placeholder={field.placeholder}
            {...field.input}
            maxLength={field.maxlength ? field.maxlength : ""}
          />
          <div className="text-help label-text-help">
            {field.meta.touched ? field.meta.error : ""}
          </div>
        </div>
      </div>
    );
  }

  onFormSubmit = (values) => {
    var { session, userRestPasswordModal } = this.props;
    var user = userRestPasswordModal.selecteduser;

    this.setState({ loading: true });
    this.props.resetUserPassword(session, values, user, (response) => {
      if (response.success === 1) {
        this.props.showSuccess(LocaleStrings.user_password_reset_success);
      } else {
        this.props.showError(COMMON_FAIL_MESSAGE);
      }
      this.setState({ loading: false });
      this.closeModal();
    });
  };

  render() {
    var { handleSubmit, invalid, pristine, submitting, userRestPasswordModal } =
      this.props;

    return (
      <Modal
        className="modal-container"
        show={userRestPasswordModal.show === true ? true : false}
        onHide={this.closeModal}
        animation={true}
      >
        <form onSubmit={handleSubmit(this.onFormSubmit)}>
          <Modal.Body>
            <div className="import-header">
              <div className="import-modal-title">
                {LocaleStrings.reset_password}
              </div>
              <button
                type="button"
                className="close btn-sm btn-close "
                onClick={() => this.closeModal()}
                style={{ marginTop: -25 }}
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>

            <div style={{ padding: 20 }}>
              <div className="form-group row">
                <label className="control-label col-sm-3">
                  {LocaleStrings.user_form_label_email}
                </label>
                <div
                  className="col-sm-9 col-sm-offset-0"
                  style={{
                    padding: "6px 14px",
                    fontWeight: "bold",
                    color: "#4da1ff",
                  }}
                >
                  {userRestPasswordModal.selecteduser.email}
                </div>
              </div>
              <Field
                name="password"
                label={LocaleStrings.reset_password_form_label_new_password}
                placeholder={LocaleStrings.reset_password_form_ph_new_password}
                type="password"
                mandatory="true"
                component={this.renderFieldText}
              />
            </div>
          </Modal.Body>
          <Modal.Footer>
            <Button className="button-theme" onClick={this.closeModal}>
              {LocaleStrings.button_close}
            </Button>
            <Button
              className="button-theme button-theme-blue"
              bsStyle="primary"
              loading={this.state.loading}
              disabled={pristine || invalid || submitting}
              type="submit"
            >
              {LocaleStrings.button_save}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    );
  }
}

function validate(values) {
  var errors = {};
  var password = values["password"];

  if (!password || password.trim() === "") {
    errors["password"] = LocaleStrings.user_validation_required;
  } else if (password && password.length < 6) {
    errors["password"] = LocaleStrings.user_password_length_validation;
  }

  return errors;
}

function mapStateToProps(state) {
  return {
    session: state.session,
    userRestPasswordModal: state.userRestPasswordModal,
  };
}

export default connect(mapStateToProps, {
  resetUserPassword,
  resetPasswordModal,
  showSuccess,
  showError,
})(
  reduxForm({
    validate,
    form: "userResetPasswordForm",
    enableReinitialize: true,
    keepDirtyOnReinitialize: true,
  })(UserResetPassword)
);
